import { Input, message, Modal, Typography } from 'antd'
import React, { useEffect, useState } from 'react'
import { useRecoilState } from 'recoil'
import Swal from 'sweetalert2'
import {
  approveApproval,
  createApproval,
  createDraftApproval,
  deleteApproval,
  getApprovalDetail,
  holdApproval,
  submitDraftApproval,
  updateApproval,
  updateDraftApproval,
} from '../../../api/electronicApproval.api'
import '../../../components/apos/modal/aopsCommonModal.scss'
import AopsCommonModalLayout from '../../../components/apos/modal/AopsCommonModalLayout'
import ModalStatusButtonGroup from '../../../components/apos/modal/ModalStatusButtonGroup'
// import ModalToggleButton from '../../../components/apos/modal/ModalToggleButton'
import ModalToggleButton from '../../../components/apos/modal/ModalToggleButton'
import { userAuthStatus, userState } from '../../../store/user'

const { Text } = Typography
const { TextArea } = Input
const windowWidth = window.innerWidth

const ApprovalPopup = ({
  open,
  onClose,
  popupMode,
  selectedApprovalId,
  isChief,
  selectedApprovalStatus,
  refetchApprovalList,
  setSelectedApprovalId,
}) => {
  //CORE, IMPROVEMENT,
  const [authStatus] = useRecoilState(userAuthStatus)
  const [user] = useRecoilState(userState)

  const [formData, setFormData] = useState({
    what: '',
    whatChecks: [false, false, false, false],
    why: '',
    taskType: 'CORE', // '업무 개선' or '필수 업무'   //CORE, IMPROVEMENT,
    howTo: '',
    description: '',
    isUrgent: false,
  })

  const [chiefFormData, setChiefFormData] = useState({
    comment: '',
    contributionLevel: 'EXTRA_CONTRIBUTED',
    // EXTRA_CONTRIBUTED,
    // REGULAR_CONTRIBUTED,
    // EFFORT
  })

  const confirmSubmit = (type) => {
    const tile = type === 'SUBMIT_NEW' ? '기안서 등록' : '초안 작성'
    const content =
      type === 'SUBMIT_NEW'
        ? '기안서를 등록하시겠습니까?'
        : '임시저장하시겠습니까?'
    Modal.confirm({
      title: tile,
      content: content,
      onOk: () => handleSubmit(type),
      onCancel: () => {},
    })
  }

  //  초안 작성 버튼 클릭 시
  const handleSubmit = async (type) => {
    // TODO: API 호출

    const param = {
      submitterId: user.id,
      title: formData.what,
      workGoal: formData.why,
      workType: formData.taskType,
      workProcess: formData.howTo,
      // detail: formData.description,
      // v1.1 detail이랑 howto 같이 쓰게로 변경되었음
      detail: '',
      studioName: authStatus.studioName,
      isUrgent: formData.isUrgent || false,
    }
    if (!validateForm(type)) return
    try {
      const res =
        type === 'SUBMIT_DRAFT'
          ? await createDraftApproval(param)
          : await createApproval(param)
      console.log('res::', res)
      handleReset()
      refetchApprovalList()
    } catch (error) {
      console.log('error::', error)
      showErrorPopup(error)
    }
  }

  const validateForm = (type) => {
    if (type === 'SUBMIT_DRAFT') {
      return true
    }
    if (!formData.what) {
      message.error('업무명을 입력해주세요')
      return false
    }
    if (!formData.why) {
      message.error('업무의 목적(why)를 적어주세요')
      return false
    }
    if (!formData.taskType) {
      message.error('업무 유형을 선택해주세요')
      return false
    }
    if (!formData.howTo) {
      message.error('어떤 방식으로 업무를 제안할건지 적어주세요')
      return false
    }

    return true
  }

  const handleReset = () => {
    setFormData({
      what: '',
      whatChecks: [false, false, false, false],
      why: '',
      taskType: 'CORE',
      howTo: '',
      description: '',
      isUrgent: false,
    })
    setChiefFormData({
      comment: '',
      contributionLevel: 'EXTRA_CONTRIBUTED',
    })
    setSelectedApprovalId(null)
    onClose()
  }

  const showErrorPopup = (error) => {
    const errorData = error?.response?.data
    let errorMessage = '오류가 발생했습니다.'

    if (errorData?.detail && Array.isArray(errorData.detail)) {
      // 두 번째 항목에 description이 있으면 사용
      const detailMessages = errorData.detail
        .filter((item) => item.description)
        .map((item) => item.description)
        .join('<br/>')
      errorMessage = detailMessages || errorMessage
    } else if (errorData?.message) {
      errorMessage = errorData.message
    }

    Swal.fire({
      customClass: { popup: 'custom-alert' },
      icon: 'error',
      title: '오류',
      html: errorMessage,
      confirmButtonText: '확인',
      confirmButtonColor: '#117FFA',
    })
  }

  const handleUpdate = async (status) => {
    // console.log('handleUpdate::', formData)
    const param = {
      submitterId: user.id,
      title: formData.what,
      workGoal: formData.why,
      workType: formData.taskType,
      workProcess: formData.howTo,
      detail: formData.description,
      studioName: authStatus.studioName,
      isUrgent: formData.isUrgent || false,
    }
    try {
      const res =
        selectedApprovalStatus === 'DRAFT'
          ? await updateDraftApproval(selectedApprovalId, param)
          : await updateApproval(selectedApprovalId, param)

      // console.log('res::', res)
      Swal.fire({
        customClass: { popup: 'custom-alert' },
        icon: 'success',
        title: '수정 완료',
        text: '기안서가 수정되었습니다.',
        confirmButtonText: '확인',
        confirmButtonColor: '#117FFA',
      }).then(() => {
        handleReset()
        refetchApprovalList()
      })
    } catch (error) {
      console.log('error::', error)
      showErrorPopup(error)
    }
  }

  useEffect(() => {
    // setSelectedApprovalId(null)
    if (selectedApprovalId && popupMode !== 'REGISTER') {
      const fetchApprovalDetail = async () => {
        const param = {
          salusUserId: user.id,
          proposalId: selectedApprovalId,
        }
        try {
          const res = await getApprovalDetail(param)

          // API 응답 데이터를 formData에 매핑
          setFormData({
            what: res.title || '',
            whatChecks: [false, false, false, false],
            why: res.workGoal || '',
            taskType: res.workType || 'CORE',
            howTo: res.workProcess || '',
            description: res.detail || '',
            isUrgent: res.isUrgent || false,
          })
          setChiefFormData({
            comment: res.comment || '',
            contributionLevel: res.contributionLevel || 'EXTRA_CONTRIBUTED',
          })
        } catch (error) {
          console.log('error::', error)
          showErrorPopup(error)
        }
      }
      fetchApprovalDetail()
    } else if (popupMode === 'REGISTER') {
      // REGISTER 모드일 때는 초기화
      // handleReset()
      setFormData({
        what: '',
        whatChecks: [false, false, false, false],
        why: '',
        taskType: 'CORE',
        howTo: '',
        description: '',
        isUrgent: false,
      })
      setChiefFormData({
        comment: '',
        contributionLevel: 'EXTRA_CONTRIBUTED',
      })
    }
  }, [selectedApprovalId, popupMode])

  /**
   * 관리자 승인 처리
   */
  const confirmHoldApproval = (type) => {
    const title = type === 'hold' ? '보류 처리' : '승인 처리'
    Swal.fire({
      title: title,
      text: `${title}하시겠습니까?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: type === 'hold' ? '보류' : '승인',
      cancelButtonText: '취소',
    }).then((result) => {
      if (result.isConfirmed) {
        handleHoldApproval(type)
      }
    })
  }

  const handleHoldApproval = async (type) => {
    const param = {
      proposalId: selectedApprovalId,
      answererId: user.id,
      contributionLevel: chiefFormData.contributionLevel,
      comment: chiefFormData.comment,
    }
    try {
      const res =
        type === 'hold'
          ? await holdApproval(param)
          : await approveApproval(param)

      refetchApprovalList()
      handleReset()
    } catch (error) {
      console.log('error::', error)
      showErrorPopup(error)
    }
  }

  const handleDelete = async () => {
    // console.log('삭제:', proposalId)
    // TODO: 삭제 로직 구현
    try {
      const res = await deleteApproval(selectedApprovalId)
      console.log('res::', res)
      Swal.fire({
        customClass: { popup: 'custom-alert' },
        icon: 'success',
        title: '삭제 완료',
        text: '기안서가 삭제되었습니다.',
        confirmButtonText: '확인',
        confirmButtonColor: '#117FFA',
      }).then(() => {
        refetchApprovalList()
        handleReset()
      })
    } catch (error) {
      console.log('error::', error)
      // showErrorPopup(error)

      return
    }
  }

  const handleSubmitDraft = async () => {
    try {
      Swal.fire({
        customClass: { popup: 'custom-alert' },
        icon: 'success',
        title: '최종 제출 하겠습니까?',
        text: '최종 제출 후 수정이 불가능합니다.',
        confirmButtonText: '최종 제출',
        cancelButtonText: '취소',
        confirmButtonColor: '#117FFA',
      }).then(async (result) => {
        if (result.isConfirmed) {
          const param = {
            submitterId: user.id,
            title: formData.what,
            workGoal: formData.why,
            workType: formData.taskType,
            workProcess: formData.howTo,
            detail: formData.description,
            studioName: authStatus.studioName,
            isUrgent: formData.isUrgent || false,
          }
          try {
            const resSaveFirst = await updateDraftApproval(
              selectedApprovalId,
              param,
            )
            const res = await submitDraftApproval(selectedApprovalId, user.id)
            console.log('res::', res)
            refetchApprovalList()
            handleReset()
          } catch (error) {
            console.log('error::', error)
            showErrorPopup(error)
            return
          }
        }
      })
    } catch (error) {
      console.log('error::', error)
      showErrorPopup(error)
      return
    }
  }

  const isReadOnly =
    popupMode?.includes('VIEW') ||
    (selectedApprovalStatus &&
      selectedApprovalStatus !== 'PENDING' &&
      selectedApprovalStatus !== 'DRAFT')

  return (
    <AopsCommonModalLayout
      title={isChief ? '기안서 결재' : '기안서 등록'}
      onClose={onClose}
      open={open}
    >
      <>
        <div className="form-container">
          <div className="form-wrapper">
            {/* what */}
            <div className="form-section">
              <label className="form-label">what</label>
              <div style={{ width: '100%' }}>
                <Input
                  placeholder="어떤 문제를 발견하셨나요?"
                  value={formData.what}
                  onChange={(e) =>
                    setFormData({ ...formData, what: e.target.value })
                  }
                  className="form-input"
                  readOnly={isReadOnly}
                />
                <div className="example-text-group">
                  <Text className="example-text">
                    조직을 더 나은 방향으로 움직이는 제안을 해주세요
                  </Text>
                  <Text
                    className="example-text"
                    style={{
                      fontSize: '12px',
                      color: '#585F65',
                      fontWeight: '400',
                    }}
                  >
                    배경과 맥락을 함께 남길수록, 팀은 더 빠르고 건강한
                    의사결정을 할 수 있어요
                  </Text>
                </div>
              </div>
            </div>

            {/* why */}
            <div className="form-section">
              <label className="form-label">why</label>
              <div className="input-with-counter">
                <Input
                  placeholder="왜 그렇게 생각하셨나요?"
                  value={formData.why}
                  onChange={(e) => {
                    if (e.target.value.length <= 30) {
                      setFormData({ ...formData, why: e.target.value })
                    }
                  }}
                  readOnly={isReadOnly}
                  className="form-input"
                />
                <span className="char-counter">
                  {formData.why.length}자/{30}자
                </span>
              </div>
            </div>

            {/* 업무 유형 */}
            <div className="form-section">
              <label className="form-label">업무 유형</label>

              <ModalStatusButtonGroup
                options={['업무 개선', '필수 업무']}
                value={formData.taskType === 'CORE' ? '업무 개선' : '필수 업무'}
                onChange={(value) => {
                  setFormData({
                    ...formData,
                    taskType: value === '업무 개선' ? 'CORE' : 'IMPROVEMENT',
                  })
                }}
              />
            </div>
            <div className="form-section">
              <label className="form-label">상태</label>

              <ModalToggleButton
                label="우선 요청"
                isActive={formData.isUrgent}
                onClick={() => {
                  setFormData({
                    ...formData,
                    isUrgent: formData.isUrgent ? false : true,
                  })
                }}
              />
            </div>

            {/* How to */}
            <div className="form-section" style={{ alignItems: 'flex-start' }}>
              <label className="form-label">How to</label>
              <div
                className="textarea-with-counter horizontal"
                style={{ width: '100%' }}
              >
                <TextArea
                  readOnly={isReadOnly}
                  placeholder="어떻게 해결하면 좋을지 알려주세요"
                  value={formData.howTo}
                  onChange={(e) => {
                    if (e.target.value.length <= 300) {
                      setFormData({ ...formData, howTo: e.target.value })
                    }
                  }}
                  className="form-textarea"
                  rows={6}
                />
                <span className="char-counter">
                  {formData.howTo.length}자/{300}자
                </span>
              </div>
            </div>

            {/* 상세 설명 */}
            {/* <div className="form-section">
              <label className="form-label">상세 설명</label>
              <div className="textarea-with-counter">
                <TextArea
                  readOnly={isReadOnly}
                  placeholder="업무에 대한 간단한 설명을 적어주세요"
                  value={formData.description}
                  onChange={(e) => {
                    if (e.target.value.length <= 300) {
                      setFormData({ ...formData, description: e.target.value })
                    }
                  }}
                  className="form-textarea"
                  rows={6}
                />
                <span className="char-counter">
                  {formData.description.length}자/{300}자
                </span>
              </div>
            </div> */}
          </div>
          {isChief && (
            <div className="form-wrapper" style={{ marginTop: '40px' }}>
              {/* 관리자 결재 폼 */}

              <>
                <div className="form-section">
                  <label className="form-label">코멘트</label>
                  <Input
                    value={chiefFormData.comment}
                    readOnly={selectedApprovalStatus !== 'PENDING'}
                    onChange={(e) =>
                      setChiefFormData({
                        ...chiefFormData,
                        comment: e.target.value,
                      })
                    }
                  />
                </div>
                {/* <div className="form-section">
                  <label className="form-label">기여도</label>
                  <div className="button-group">
                    <Button
                      type={
                        chiefFormData.contributionLevel === 'EXTRA_CONTRIBUTED'
                          ? 'primary'
                          : 'default'
                      }
                      onClick={() => {
                        if (selectedApprovalStatus !== 'PENDING') return
                        setChiefFormData({
                          ...chiefFormData,
                          contributionLevel: 'EXTRA_CONTRIBUTED',
                        })
                      }}
                    >
                      EXTRA 기여
                    </Button>
                    <Button
                      type={
                        chiefFormData.contributionLevel ===
                        'REGULAR_CONTRIBUTED'
                          ? 'primary'
                          : 'default'
                      }
                      onClick={() => {
                        if (selectedApprovalStatus !== 'PENDING') return
                        setChiefFormData({
                          ...chiefFormData,
                          contributionLevel: 'REGULAR_CONTRIBUTED',
                        })
                      }}
                    >
                      REGULAR 기여
                    </Button>
                    <Button
                      type={
                        chiefFormData.contributionLevel === 'EFFORT'
                          ? 'primary'
                          : 'default'
                      }
                      onClick={() => {
                        if (selectedApprovalStatus !== 'PENDING') return
                        setChiefFormData({
                          ...chiefFormData,
                          contributionLevel: 'EFFORT',
                        })
                      }}
                    >
                      노력했어요
                    </Button>
                  </div>
                </div> */}
              </>
            </div>
          )}
        </div>

        {/* 버튼 */}
        {/* 일단 어떤 상황이어도 대기 상태일때만 보이니까 먼저 체크 */}
        {(!selectedApprovalStatus ||
          selectedApprovalStatus === 'PENDING' ||
          selectedApprovalStatus === 'DRAFT') && (
          <div className="popup-footer">
            {/* 멤버 뷰  => 그냥 안 보임*/}
            {popupMode === 'MEMBER_VIEW' && <></>}
            {/* 대표님 뷰 */}
            {popupMode === 'MASTER_VIEW' && (
              <>
                <button
                  className="btn-cancel"
                  onClick={() => confirmHoldApproval('hold')}
                >
                  보류
                </button>
                <button
                  className="btn-submit"
                  onClick={() => confirmHoldApproval('approve')}
                >
                  승인
                </button>
              </>
            )}
            {/* 수정이다 등록 */}
            {(popupMode === 'EDIT' || popupMode === 'REGISTER') && (
              <>
                {selectedApprovalStatus !== 'DRAFT' && (
                  <button className="btn-cancel" onClick={handleReset}>
                    취소
                  </button>
                )}
                <button
                  className="btn-submit"
                  onClick={
                    popupMode === 'REGISTER'
                      ? () => confirmSubmit('SUBMIT_NEW')
                      : () => handleUpdate(formData.status)
                  }
                >
                  {popupMode === 'REGISTER' ? '등록' : '수정'}
                </button>
                {selectedApprovalStatus === 'DRAFT' &&
                  popupMode !== 'REGISTER' && (
                    <button
                      className="btn-draft"
                      onClick={() => handleSubmitDraft()}
                    >
                      최종 제출하기
                    </button>
                  )}
                {selectedApprovalStatus === 'DRAFT' && (
                  <button
                    className="btn-draft btn-draft-delete"
                    onClick={() => handleDelete()}
                  >
                    삭제
                  </button>
                )}
              </>
            )}

            {/* 🔥 초안 작성 버튼 추가 , 등록할 때만 보이니까*/}
            {popupMode === 'REGISTER' && (
              <button
                className="btn-draft btn-draft-create"
                onClick={() => confirmSubmit('SUBMIT_DRAFT')}
              >
                임시저장
              </button>
            )}
          </div>
        )}
      </>
    </AopsCommonModalLayout>
  )
}

export default ApprovalPopup
